import { createContext, useContext, useState } from "react"
import SerialScannerModal from "../common_component/SerialScannerModal"
import CurrencyModal from "../common_component/CurrencyModal"
import BulkUploadModal from "../common_component/BulkUploadModal"
import GoogleMapsModal from "../common_component/GoogleMapsModal"
import ProductCodeModal from "../common_component/ProductCodeModal"
import ProductQrGeneratorModal from "../common_component/ProductQrGeneratorModal"
import ProductQrReaderModal from "../common_component/ProductQrReaderModal"
import ProductQrStockReaderModal from "../common_component/ProductQrStockReaderModal"
import GstInModal from "../common_component/GstInModal"
import TrackingModal from "../common_component/TrackingModal"
import RevertModal from "../common_component/RevertModal"

const initialState = {
    displayModal: false,
    modalView: null,
    modalData: null,
}

const ModalContext = createContext(initialState)

export function ModalProvider({ children }) {
    const [displayModal, setDisplayModal] = useState(false)
    const [modalView, setModalView] = useState(null)
    const [modalData, setModalData] = useState(null)


    const openModal = () => { setDisplayModal(true) }
    const closeModal = () => { setDisplayModal(false) }

    const value = {
        displayModal,
        modalView,
        modalData,
        openModal,
        closeModal,
        setModalView,
        setModalData
    };

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    )
}

export const useModal = () => {
    const context = useContext(ModalContext);
    if (context === undefined) {
        throw new Error(`useModal must be used within a ModalProvider`);
    }
    return context;
};

export const ManagedModal = () => {
    const { modalView } = useModal();

    return (
        <>
            {modalView === "SERIAL_SCANNER_MODAL" && <SerialScannerModal />} {/* This modal is used to add serials for an item directly into the db after verification of duplicate serials against all serials of all items */}
            {modalView === "CURRENCY_MODAL" && <CurrencyModal />} {/* This modal is used to add/edit currency into db */}
            {modalView === "BULK_UPLOAD_MODAL" && <BulkUploadModal />} {/* This modal is used to add/edit currency into db */}
            {modalView === "GOOGLE_MAPS_MODAL" && <GoogleMapsModal />} {/* This modal is used to select/update a location into google maps and return it for some use */}
            {modalView === "PRODUCT_CODE_MODAL" && <ProductCodeModal />} {/* This modal is used to search hsn/sac product codes and select them */}
            {modalView === "GSTIN_MODAL" && <GstInModal />} {/* This modal is used to select/update a location into google maps and return it for some use */}
            {modalView === "PRODUCT_QR_SCANNER_MODAL" && <ProductQrGeneratorModal />} {/* This modal is used to search hsn/sac product codes and select them */}
            {modalView === "PRODUCT_QR_READER_MODAL" && <ProductQrReaderModal />}
            {modalView === "PRODUCT_QR_STOCK_READER_MODAL" && <ProductQrStockReaderModal />}
            {modalView === "TRACKING_VIEW" && <TrackingModal />}
            {modalView === "REVERT_MODAL" && <RevertModal />}

        </>
    );
};